import { FilterColumn } from "types";
import { onlyDigits } from "validators";

const terminalNumberColumn = ({
	name = "terminalNumber",
	placeholder = "Terminal Solution #",
} = {}): FilterColumn => ({
	name,
	type: "input" as const,
	placeholder,
	normalize: onlyDigits,
});

export default terminalNumberColumn;
